import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const paths = [
  {
    n: "01",
    title: "Business & Brand Consulting",
    desc: "Founder-level ownership, field-tested leadership, and cultural intelligence for organizations that need a clearer path forward.",
    accent: "gold",
    to: "/work-with-toriano?type=business",
    cta: "Request a Consultation",
  },
  {
    n: "02",
    title: "AI Coaching & Technology",
    desc: "Practical, accessible AI strategy for entrepreneurs and professionals. Start with an AI Super Session — $150.",
    accent: "royal",
    to: "/work-with-toriano?type=ai",
    cta: "Book an AI Super Session",
  },
  {
    n: "03",
    title: "Speaking & Workshops",
    desc: "Keynotes, conferences, colleges, and private leadership sessions on animal psychology, abundance, and reinvention.",
    accent: "emerald",
    to: "/work-with-toriano?type=event",
    cta: "Book Toriano to Speak",
  },
  {
    n: "04",
    title: "Books, Media & Education",
    desc: "The Consciousness of Abundance · Wolf Keeper 2.0 · interviews, podcasts, and long-form ideas that move people.",
    accent: "burgundy",
    to: "/books-media",
    cta: "Explore Books & Media",
  },
  {
    n: "05",
    title: "Golden Wolf Foundation",
    desc: "Supporting veterans, service-dog programs, and workforce pathways — build purpose through the human-canine bond.",
    accent: "gold",
    to: "/golden-wolf",
    cta: "Support Golden Wolf",
  },
];

const accentClasses = {
  gold: "border-gold/40 hover:border-gold",
  royal: "border-royal/60 hover:border-royal",
  emerald: "border-emerald/60 hover:border-emerald",
  burgundy: "border-blood/60 hover:border-blood",
};

const accentText = {
  gold: "text-gold",
  royal: "text-royal",
  emerald: "text-emerald",
  burgundy: "text-blood",
};

export default function Pathways() {
  return (
    <section className="section bg-ink-2" data-testid="pathways-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">04 / More Than Dog Training</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.4rem,6vw,6rem)] leading-[0.95] tracking-[-0.02em]">
              The same principles.<br/><span className="italic gold-foil">A bigger mission.</span>
            </h2>
            <p className="mt-6 max-w-2xl text-bone/75 text-lg font-editorial">
              Companies, communities, families and founders now access the complete Toriano Sanzone experience — the same leadership, psychology and systems that transform dogs, applied to people, brands and organizations.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {paths.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.06 * i }}
              className={`tilt-card border ${accentClasses[p.accent]} bg-ink p-8 md:p-10 flex flex-col`}
              data-testid={`pathway-${p.n}`}
            >
              <div className={`text-hair ${accentText[p.accent]} mb-3`}>{p.n} · Path</div>
              <h3 className="font-display text-3xl md:text-4xl leading-tight">{p.title}</h3>
              <p className="mt-4 text-bone/70 flex-grow">{p.desc}</p>
              <Link to={p.to} className="mt-6 text-hair text-bone hover:text-gold flex items-center gap-2 self-start border-b border-bone/30 hover:border-gold pb-1">
                {p.cta}
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
